import React from 'react'
import { QuestionUtils } from '../../../utils/siteUtils'
import Question from './Question'
import { ButtonGroupWrap } from '../buttonGroup'

export default ({ getQuestionResponse, saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment, question }) => {
  const { questionLabel, questionChoices } = QuestionUtils.getQuestionLabelAndChoices(question)

  return (
    <Question question={{ ...question, acceptsComment: false }} title={questionLabel} subtitle={question.labelExtended} {...{ saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment }}>
      <ButtonGroupWrap>
        {questionChoices.map((label, n) => (
          <Question
            key={n}
            question={question.selectChoices[n]}
            selectedIndex={getQuestionResponse(question.selectChoices[n].qRef).v}
            questionChoices={[label]}
            questionId={question.selectChoices[n].qRef}
            {...{ saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment }}
          />
        ))}
      </ButtonGroupWrap>
    </Question>
  )
}
